import { INoteEntity } from "sh-models";
import { mutatorAction } from "satcheljs";
import { ObservableMap } from "mobx";
import schedulesViewStateStore from "../../store/store";
import { SchedulesViewStateStore } from "../../store/schema/SchedulesViewStateStore";
import { IPreviewSchedulePageStore } from "../../../../previewSchedulePage";

export default mutatorAction('DELETE_NOTES_IN_VIEW', function deleteNotesInView(
    notesToDelete: INoteEntity[],
    viewState?: IPreviewSchedulePageStore | SchedulesViewStateStore
) {
    let notes: ObservableMap<string, INoteEntity> = viewState ? viewState.notesInView : schedulesViewStateStore().notesInView;
    for (let i = 0; i < notesToDelete.length; i++) {
        notes.delete(notesToDelete[i].id);
    }
});
